import { Building2, Users } from "lucide-react";
import type { AccountKind } from "./plan-selection";

/**
 * Step 1 of the calculator: operator vs. property manager. The kind never
 * changes prices — it swaps plan labels and which add-ons are purchasable
 * (operators: Revenue + Research; PMs: Owner Portals + CPM listing).
 */
export function AccountTypeToggle({
  value,
  onChange,
}: {
  value: AccountKind;
  onChange: (kind: AccountKind) => void;
}) {
  const options: Array<{ kind: AccountKind; label: string; blurb: string; icon: typeof Building2 }> = [
    {
      kind: "operator",
      label: "Operator",
      blurb: "I run my own co-living portfolio",
      icon: Building2,
    },
    {
      kind: "property_manager",
      label: "Property Manager",
      blurb: "I manage properties for owners",
      icon: Users,
    },
  ];
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="toggle-account-type">
      {options.map(({ kind, label, blurb, icon: Icon }) => {
        const active = value === kind;
        return (
          <button
            key={kind}
            type="button"
            onClick={() => onChange(kind)}
            className={`rounded-xl border-2 p-4 text-left transition-all ${
              active
                ? "border-brand bg-brand/5 shadow-sm"
                : "border-gray-200 bg-white hover:border-gray-300"
            }`}
            aria-pressed={active}
            data-testid={`card-account-type-${kind}`}
          >
            <div className="flex items-center gap-2 mb-1">
              <Icon size={18} className={active ? "text-brand" : "text-gray-400"} />
              <span className={`font-semibold ${active ? "text-brand" : "text-gray-900"}`}>{label}</span>
            </div>
            <p className="text-sm text-gray-500">{blurb}</p>
          </button>
        );
      })}
    </div>
  );
}
